import { home_repeatNav_children, bigScreen_repeatNav_children, app_repeatNav_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxRepeatNav = {
  name: "cxRepeatNav",
  desc: "",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "平铺导航",
        group: "highLevel",
        children: app_repeatNav_children,
        thumbnail: "icon-portal-repeat_nav",
        sort: 60
      }
    ],
    bigScreen: [],
    portal: [
      {
        name: "平铺导航",
        children: [],
        thumbnail: "icon-portal-repeat_nav",
        group: "highLevel",
        sort: 60
      }
    ]
  },
  toolbars: [
    {
      name: "cxRepeatNav",
      label: "平铺导航",
      comp: {
        repeatNavComponentData: () => import("./toolbars/repeatNav-options-data.vue"),
        repeatNavComponentSetting: () => import("./toolbars/repeatNav-options-setting.vue"),
        repeatNavComponentStyle: () => import("./toolbars/repeatNav-options-style.vue"),
        repeatNavComponentConfig: () => import("./toolbars/repeatNav-options-config.vue")
      }
    }
  ]
}

export default cxRepeatNav
